export default __webpack_public_path__ + "static/media/Poppinspoppins-boldsemibold.89dc8c3f.ttf";